module.exports = __webpack_public_path__ + "files/11b0811bec7a20291df253961f0e9362.png";